import { render, staticRenderFns } from "./Declarations.vue?vue&type=template&id=a8067fe4&"
import script from "./Declarations.vue?vue&type=script&lang=ts&"
export * from "./Declarations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports